import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "PersonaPhoto" */ './lazyIndex')
);

export let lazyDownloadPersonaPhoto = new LazyAction(lazyModule, m => m.downloadPersonaPhoto);
